import { or } from 'macro-decorators';
import { service } from '@ember/service';
// eslint-disable-next-line ember/no-mixins
import FastbootHelpersMixin from 'client-portal/mixins/route/fastboot-helpers';
import Route from '@ember/routing/route';

const ExtendedRoute = Route.extend(FastbootHelpersMixin);

export default class SiteBillingInsuranceNew extends ExtendedRoute {
  @service router;
  @service store;
  @service currentPractice;

  @or('currentPractice.featureCpInsuranceInfo', 'currentPractice.claimAssistantSettingActive')
  insuranceFeatureEnabled;

  beforeModel() {
    super.beforeModel(...arguments);

    if (!this.insuranceFeatureEnabled) {
      return this.router.transitionTo('site.billing');
    }

    let client = this.modelFor('site.billing');
    if (!client) {
      return this.router.transitionTo('site.billing');
    }
  }

  async model() {
    let client = this.modelFor('site.billing');

    let newInsurance = this.store.createRecord('insurance-info', {
      client,
      insuredRelation: '0', // Default to 'Self'
      isDirty: false,
    });

    return {
      client,
      insuranceInfo: newInsurance,
    };
  }
}
